import React from 'react';

function formatLineMeta(item) {
    const parts = [];
    if (item.selectedSize) parts.push(`Size ${item.selectedSize}`);
    if (item.selectedQty) parts.push(`Qty ${item.selectedQty}`);
    return parts.join(' · ');
}

/**
 * Per-line product breakdown for a store-credit ledger entry.
 */
export function CreditTransactionDetails({ items, className = '' }) {
    if (!items?.length) return null;

    return (
        <ul className={`credit-txn-items ${className}`.trim()} aria-label="Order items">
            {items.map((item) => {
                const meta = formatLineMeta(item);
                const paid =
                    item.lineFinalAmount > 0
                        ? `Paid ₹${item.lineFinalAmount.toLocaleString('en-IN')}`
                        : null;
                return (
                    <li key={item.orderItemId} className="credit-txn-items__row">
                        <div className="credit-txn-items__main">
                            <span className="credit-txn-items__title">{item.productTitle}</span>
                            {meta ? <span className="credit-txn-items__meta">{meta}</span> : null}
                            {paid ? <span className="credit-txn-items__meta">{paid}</span> : null}
                        </div>
                        {item.creditAmount > 0 ? (
                            <span className="credit-txn-items__credit">
                                ₹{item.creditAmount.toLocaleString('en-IN')}
                            </span>
                        ) : null}
                    </li>
                );
            })}
        </ul>
    );
}
